import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ComingSoon from './components/ComingSoon';
import TokenRouter from './components/TokenRouter';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* / → Coming Soon */}
        <Route path="/" element={<ComingSoon />} />

        {/* /:token → Token Router (auto-resolves the token) */}
        <Route path="/:token" element={<TokenRouter />} />
      </Routes>
    </BrowserRouter>
  );
}
